module.exports = __webpack_public_path__ + "static/media/pit3.5ef4f390.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/pitahaya/pit3.jpeg
// module id = 44
// module chunks = 0